import cx from 'classnames';

const Layout = ({ children, className }) => {
  return (
    <main className="bg-white pb-10 flex flex-col w-screen overflow-y-auto h-screen">
      <div
        className={cx('mx-auto max-w-[544px] w-full md:w-[33vw]', className)}
      >
        {children}
      </div>
    </main>
  );
};

export default Layout;
